module.exports = __webpack_public_path__ + "img/coffee-shop.7769a881.png";